<template>
  <div class="global-container">
    <div v-for="(option, index) in options" :key="index" class="card" :class="{deactivated : option.state === 'DEACTIVATED', owned: option.owned}">
      <h3 class="card-title">{{ option.title }}</h3>
      <p class="card-description">{{ option.description }}</p>
      <p class="card-price"><s>{{ option.price }} €/mois</s> gratuit</p>
      <CustomButton class="button" @click="$refs.confirmOptionModal.openModal(option)" :params=option.button />
    </div>
    <CustomLoader ref="loader"/>
  </div>
  <ConfirmOptionModal ref="confirmOptionModal" />
</template>

<script>
import { OptionController } from "@/controllers/user/OptionController";
import CustomButton from "@/components/forms/customs/customButton/CustomButton.vue";
import ConfirmOptionModal from "@/components/modals/ConfirmOptionModal.vue";
import CustomLoader from "@/components/CustomLoader.vue";

export default {
  name: 'OptionList',
  components: {CustomLoader, ConfirmOptionModal, CustomButton},
  data() {
    return {
      options: [],
      buttons: {
        buy : {text : "Acheter"}
      }
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.$refs.loader?.startLoading();
      const resp = await OptionController.getAll();
      if (!resp.errors) {
        resp.forEach(option => {
          const owned = localStorage.options && localStorage.options.includes(option.name);
          option.button = owned ? { text: 'Retirer' } : { text: 'Obtenir' };
          option.button.disabled = option.state === "DEACTIVATED";
          option.owned = localStorage.options && localStorage.options.includes(option.name);
        });
        this.options = resp;
      } else {
        this.options = [];
      }
      this.$refs.loader?.stopLoading();
    }
  }
}
</script>

<style lang="stylus" scoped>
  @require '~/src/common/style/common.styl'

  .global-container
    position relative
    display grid
    grid-template-columns repeat(auto-fill, minmax(220px, 1fr))
    gap 20px
    padding 20px

  .card
    background #eaebf1
    border-radius 12px
    box-shadow 0 4px 12px rgba(0, 0, 0, 0.06)
    padding 16px
    transition transform 0.2s ease, box-shadow 0.2s ease
    display flex
    flex-direction column
    justify-content space-between
    min-height 180px

    &:hover
      transform translateY(-3px)
      box-shadow 0 8px 20px rgba(0, 0, 0, 0.1)

    &.deactivated
      background #acacac
      .card-title
        color #656565
      p
        color #656565

    &.owned
      background-color #c1e3ca

  .card-title
    font-size 16px
    font-weight 600
    margin-bottom 6px
    color THEME_COLOR_PRIMARY

  .card-description
    font-size 13px
    color #555
    margin-bottom 10px

  .card-price
    font-size 14px
    font-weight 500
    color THEME_COLOR_PRIMARY
    margin-top auto
    margin-bottom 12px

  .button
    padding 8px 14px
</style>
